<label class="select-label">

  <select
    class="select-dropdown"
    [value]="value"
    [disabled]="disabled"
    (change)="onSelectChange($event)"
  >
    <option value="" disabled selected>
      {{ placeholder }}
    </option>

    <option
      *ngFor="let option of options"
      [value]="option.value"
    >
      {{ option.label }}
    </option>
  </select>

</label>
